import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";

import { Can, useSelectedLocation } from "components";
import { carDetailRegex } from "components/NavBar/routes";
import { PATHS } from "router/paths";

const pathsToHideDayplanner = [
  PATHS.ACCOUNT,
  PATHS.BACKORDERS_DASHBOARD,
  PATHS.CHECK_IN_SERVICES_DASHBOARD,
  PATHS.DAYPLANNER,
  PATHS.DEALER_DOCUMENTATION,
  PATHS.DEALER_REPORTS,
  PATHS.LEADS_DASHBOARD,
  PATHS.LOCATION_LICENSE_OVERVIEW,
  PATHS.LOCATION_REPORTS,
  PATHS.MANUFACTURER_DASHBOARD,
  PATHS.NEWS_DASHBOARD,
  PATHS.WARRANTY_DASHBOARD
];

export const DayplannerPageButton = () => {
  const { selectedLocation } = useSelectedLocation();

  const isDayPlannerEnabled = (!carDetailRegex.test(location.pathname) && selectedLocation?.is_dayplanner_enabled) ?? false;
  const showDayplanner = !pathsToHideDayplanner.some(path => location.pathname === path);

  if (!isDayPlannerEnabled || !showDayplanner) return null;

  return (
    <Can I="browse" the="dayplanner-page">
      <Link className="button" to={PATHS.DAYPLANNER}>
        <Icon className="square kanban regular i-grey" />
      </Link>
    </Can>
  );
};
